import React, { useEffect, useState, useRef } from 'react';
import {
  // myFilesFolderCreate,
  myFilesFolderView,
  // myFilesFolderRename,
  // myFilesFolderDelete,
  myFilesFolderList,
  myFilesFolderMove,
  uploadMyFiles,
  uploadAndClassifyMyFiles,
  copyEnvelopeToMyFiles,
} from '../../../../services/CommonService';
import { toast } from "react-toastify";
import { Button } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import { RiFileList3Line } from "react-icons/ri";
import { FaFolderClosed } from "react-icons/fa6";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { IoImages } from "react-icons/io5";
import { BsFiletypeDocx } from "react-icons/bs";
import { AiOutlineArrowUp, AiOutlineArrowDown } from 'react-icons/ai';
import { FaArrowsAlt, } from 'react-icons/fa';
import { RiDeleteBin5Line } from "react-icons/ri";
import { MdDriveFileRenameOutline } from "react-icons/md";
import { BiAlarm } from "react-icons/bi";
import mammoth from 'mammoth';
import image from '../../../../assets/svg/image.svg';
import docx from '../../../../assets/svg/docx.svg';
import folder from '../../../../assets/svg/folder.svg';
import pdf from '../../../../assets/svg/pdf.svg';
import ReminderModal from './ViewMyFiles/ReminderModal';
import { FaShare } from 'react-icons/fa';
import { useAppContext } from '../../../../context/AppContext';
import MyFilesMetadata from "./ViewMyFiles/MyFilesMetadata";
import MyFilesTag from './ViewMyFiles/MyFilesTag';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import ShareDocumentModal from "./ViewMyFiles/ShareDocumentModal";
import MoveModal from './ViewMyFiles/MoveModal';
import DeleteFilesModal from "./ViewMyFiles/DeleteFilesModal";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import { BiChevronDown } from 'react-icons/bi';
import FavoriteStar from './ViewMyFiles/FavoriteStar';
import { FaStar } from 'react-icons/fa';
import FolderActionModal from './ViewMyFiles/FolderActionModal';

const MAX_FOLDER_DEPTH = 4;

const MyFilesFolder = ({ userId, onMove, onReminderUpdate }) => {
  const { clipboardData, copyToClipboard, clearClipboard } = useAppContext();
  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [folderStack, setFolderStack] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(Date.now());
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [previewContent, setPreviewContent] = useState('');
  const [previewFile, setPreviewFile] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [modalType, setModalType] = useState('');
  const [actionType, setActionType] = useState('');
  const [name, setName] = useState('');
  const [errors, setErrors] = useState({ name: '' });
  const [selectedItem, setSelectedItem] = useState(null);
  const [availableFolders, setAvailableFolders] = useState([]);
  const [selectedDestinationFolder, setSelectedDestinationFolder] = useState(null);
  const [fetchingFolders, setFetchingFolders] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [filterType, setFilterType] = useState('all');
  const [sortColumn, setSortColumn] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [deleteConfirmationText, setDeleteConfirmationText] = useState('');
  const [isDragging, setIsDragging] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [classifyAfterUpload, setClassifyAfterUpload] = useState(false);
  const [reminderStatus, setReminderStatus] = useState({});
  const [draggedItem, setDraggedItem] = useState(null);
  const [dropTarget, setDropTarget] = useState(null);
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [clipboardItems, setClipboardItems] = useState([]);
  const [longPressActiveId, setLongPressActiveId] = useState(null);
  const [longPressType, setLongPressType] = useState(null);
  const [selectedMetadata, setSelectedMetadata] = useState(null);
  const [showMetadataModal, setShowMetadataModal] = useState(false);
  const [infoMessage, setInfoMessage] = useState('To select a folder or file, use Ctrl+Click (or Cmd+Click on Mac). To open, just click.');
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);

  const fileInputRef = useRef(null);
  let longPressTimer = null;
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (!userId || loading) return;

      setLoading(true);
      try {
        const payload = { user_id: userId, folder_id: currentFolder?.id || null };
        const response = await myFilesFolderView(payload);

        if (response.data.message !== 'success') {
          throw new Error(response.data.message || 'Failed to fetch data');
        }

        if (isMounted) {
          const responseData = response.data.data || {};
          setFolders(responseData.folders || []);
          setFiles(responseData.files || []);
          const reminders = {};
          responseData.files?.forEach((file) => {
            reminders[file.id] = file.has_reminder || false;
          });
          setReminderStatus(reminders);
        }
      } catch (err) {
        if (isMounted) {
          console.error('Error fetching data:', err);
          toast.error(err.message || 'Failed to fetch data');
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [userId, currentFolder?.id, refreshTrigger]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-menu') && !event.target.closest('.three-dots')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    const closeDropdown = () => setActiveDropdown(null);
    window.addEventListener('scroll', closeDropdown, true);
    window.addEventListener('resize', closeDropdown, true);
    return () => {
      window.removeEventListener('scroll', closeDropdown, true);
      window.removeEventListener('resize', closeDropdown, true);
    };
  }, []);

  const handleItemClick = (e, item) => {
    if (e.ctrlKey || e.metaKey) {
      setSelectedItems((prev) =>
        prev.some((selected) => selected.id === item.id && selected.type === item.type)
          ? prev.filter((selected) => !(selected.id === item.id && selected.type === item.type))
          : [...prev, item]
      );
    }
  };

  const handleDragStart = (e, item) => {
    if (!selectedItems.some((selected) => selected.id === item.id && selected.type === item.type)) {
      setSelectedItems([item]);
    }
    e.dataTransfer.setData('text/plain', JSON.stringify(selectedItems));
    setDraggedItem(selectedItems);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOverfolder = (e, folder) => {
    e.preventDefault();
    if (folder && folder.type === 'folder') {
      setDropTarget(folder);
      setIsDraggingOver(true);
    }
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragLeavefolder = () => {
    setIsDraggingOver(false);
    setDropTarget(null);
  };

  const handleDropfolder = async (e, folder) => {
    e.preventDefault();
    setIsDraggingOver(false);

    if (!draggedItem || draggedItem.length === 0 || !folder) return;

    try {
      setLoading(true);
      const folderIds = draggedItem
        .filter((item) => item.type === 'folder')
        .map((item) => item.id);
      const fileIds = draggedItem
        .filter((item) => item.type === 'file')
        .map((item) => item.id);

      const payload = {
        user_id: userId,
        folder_ids: folderIds,
        file_ids: fileIds,
        target_folder_id: folder.id
      };

      await myFilesFolderMove(payload);
      toast.success(`${draggedItem.length} Item moved successfully`);
      setRefreshTrigger(Date.now());
      setSelectedItems([]);

      if (onMove) {
        onMove({
          movedItems: draggedItem,
          targetFolder: folder,
          userId,
        });
      }
    } catch (err) {
      console.error('Error moving items:', err);
      toast.error(err.message || 'Failed to move items');
    } finally {
      setLoading(false);
      setDraggedItem(null);
      setDropTarget(null);
    }
  };

  const handlePasteToMyFiles = async () => {
    if (!clipboardData) {
      toast.info('Clipboard is empty. Copy items first.', { autoClose: 2000 });
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...clipboardData,
        target_folder_id: currentFolder?.id || null,
        user_id: userId
      };
      await copyEnvelopeToMyFiles(payload);
      toast.success('Items pasted successfully!');
      clearClipboard();
      setRefreshTrigger(Date.now());
    } catch (err) {
      console.error('Error pasting items:', err);
      toast.error(err.message || 'Failed to paste items');
    } finally {
      setLoading(false);
    }
  };

  const highlightText = (text, search) => {
    if (!search.trim()) return text;
    const regex = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    return text.split(regex).map((part, index) =>
      regex.test(part.toLowerCase()) ? <span key={index} className="highlight">{part}</span> : part
    );
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const sortItems = (folders, files) => {
    const allItems = [
      ...folders.map(folder => ({ ...folder, type: 'folder' })),
      ...files.map(file => ({ ...file, type: 'file' }))
    ];
    return allItems.sort((a, b) => {
      let comparison = 0;
      if (sortColumn === 'name') {
        const nameA = a.folder_name || a.file_name;
        const nameB = b.folder_name || b.file_name;
        comparison = nameA.localeCompare(nameB);
      } else if (sortColumn === 'date_modified') {
        const dateA = new Date(a.updated_at || a.created_at);
        const dateB = new Date(b.updated_at || b.created_at);
        comparison = dateA - dateB;
      } else if (sortColumn === 'file_type') {
        const typeA = a.type === 'folder' ? 'FOLDER' : getFileIconAndClass(a.file_name).type;
        const typeB = b.type === 'folder' ? 'FOLDER' : getFileIconAndClass(b.file_name).type;
        comparison = typeA.localeCompare(typeB);
      }
      return sortDirection === 'asc' ? comparison : -comparison;
    });
  };

  const handleFolderClick = async (folder) => {
    if (folderStack.length >= MAX_FOLDER_DEPTH) {
      toast.info(`Maximum folder depth of ${MAX_FOLDER_DEPTH} reached`);
      return;
    }

    try {
      setFolderStack(prev => {
        const newStack = currentFolder ? [...prev, currentFolder] : prev;
        setCurrentFolder(folder);
        return newStack;
      });
      const payload = { user_id: userId, folder_id: folder.id };
      const response = await myFilesFolderView(payload);
      if (response.data.message === "success") {
        const responseData = response.data.data || {};
        setFolders(responseData.folders || []);
        setFiles(responseData.files || []);
      } else {
        throw new Error(response.data.message || "Failed to fetch folder contents");
      }
    } catch (err) {
      console.error("Error in handleFolderClick:", err);
      toast.error(err.message || "Failed to open folder");
      setFolderStack(prev => prev.slice(0, -1));
      setCurrentFolder(folderStack[folderStack.length - 1] || null);
    }
  };

  const handleBack = () => {
    if (folderStack.length > 0) {
      const newStack = [...folderStack];
      const previousFolder = newStack.pop();
      setFolderStack(newStack);
      setCurrentFolder(previousFolder);
    } else {
      setCurrentFolder(null);
      setFolderStack([]);
    }
    setSelectedItems([]);
  };

  const handlePreview = async (file) => {
    setPreviewFile(file);
    setPreviewContent('');
    setIsPreviewLoading(true);
    setShowPreviewModal(true);
    const lowerName = file.file_name.toLowerCase();
    if (lowerName.endsWith('.docx') || lowerName.endsWith('.doc')) {
      try {
        const response = await fetch(file.file_path);
        if (!response.ok) throw new Error('Failed to fetch .docx file');
        const arrayBuffer = await response.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer });
        setPreviewContent(result.value);
      } catch (err) {
        console.error('Error generating .docx preview:', err);
        toast.error('Failed to load .docx preview');
        setPreviewContent('');
      } finally {
        setIsPreviewLoading(false);
      }
    } else if (lowerName.endsWith('.txt') || lowerName.endsWith('.csv')) {
      try {
        const response = await fetch(file.file_path);
        if (!response.ok) throw new Error('Failed to fetch text file');
        const text = await response.text();
        setPreviewContent(text);
      } catch (err) {
        console.error('Error loading text/csv preview:', err);
        toast.error('Failed to load text/csv preview');
        setPreviewContent('');
      } finally {
        setIsPreviewLoading(false);
      }
    } else if (lowerName.endsWith('.svg')) {
      setIsPreviewLoading(false);
      setPreviewContent(file.file_path); // We'll use this as src
    } else if (lowerName.endsWith('.ppt') || lowerName.endsWith('.pptx')) {
      setIsPreviewLoading(false);
      setPreviewContent('ppt'); // Just a flag
    } else if (lowerName.endsWith('.xlsx')) {
      try {
        const response = await fetch(file.file_path);
        if (!response.ok) throw new Error('Failed to fetch .xlsx file');
        const arrayBuffer = await response.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const html = XLSX.utils.sheet_to_html(worksheet);
        setPreviewContent(html);
      } catch (err) {
        console.error('Error loading .xlsx preview:', err);
        toast.error('Failed to load .xlsx preview');
        setPreviewContent('');
      } finally {
        setIsPreviewLoading(false);
      }
    } else {
      setIsPreviewLoading(false);
    }
  };

  const openSummaryForFile = (file) => {
    if (!file || !file.file_path) {
      toast.error("Missing document or user ID.");
      return;
    }
    const summaryData = {
      fileId: file.id,
      userId: userId,
      filePath: file.file_path,
      fileName: file.file_name,
    };
    sessionStorage.setItem("summaryData", JSON.stringify(summaryData));
    const randomId = Math.floor(Math.random() * 1000000);
    const summaryUrl = `/manage/my-files/summary/${randomId}`;
    navigate(summaryUrl); // Open in same tab
  };

  const getBreadcrumbs = () => {
    const crumbs = [];

    crumbs.push(
      <span
        key="root"
        onClick={() => {
          setCurrentFolder(null);
          setFolderStack([]);
          setSelectedItems([]);
        }}
        className={`breadcrumb-item ${!currentFolder ? 'active-crumb' : ''}`}
        onDragOver={handleDragOverfolder}
        onDrop={handleDropOnRoot}
        onDragLeave={handleDragLeavefolder}
        style={{ minWidth: 40, display: 'inline-block' }}
      >
        Home
      </span>
    );

    folderStack.forEach((folder, index) => {
      crumbs.push(
        <span key={`separator-${folder.id}`} className="breadcrumb-separator">
          <i className="bi bi-chevron-right mx-2 text-muted" />
        </span>
      );
      crumbs.push(
        <span
          key={folder.id}
          onClick={() => {
            setCurrentFolder(folder);
            setFolderStack(folderStack.slice(0, index + 1));
            setSelectedItems([]);
          }}
          className={`breadcrumb-item ${currentFolder?.id === folder.id ? 'active-crumb' : ''}`}
        >
          {folder.folder_name}
        </span>
      );
    });

    if (currentFolder && (folderStack.length === 0 || folderStack[folderStack.length - 1]?.id !== currentFolder.id)) {
      crumbs.push(
        <span key={`separator-current`} className="breadcrumb-separator">
          <i className="bi bi-chevron-right mx-2 text-muted" />
        </span>
      );
      crumbs.push(
        <span
          key={currentFolder.id}
          className="breadcrumb-item active-crumb"
        >
          {currentFolder.folder_name}
        </span>
      );
    }

    return (
      <div className="d-flex align-items-center flex-wrap">
        {crumbs}
      </div>
    );
  };

  const openModal = (type, action, item = null) => {
    setModalType(type);
    setActionType(action);
    setSelectedItem(item);
    setSelectedDestinationFolder(null);

    // For single item moves, ensure the item is in selectedItems with proper type
    if (action === 'move' && item && (type === 'file' || type === 'folder')) {
      console.log('Setting selectedItems for single item move:', { item, type });
      setSelectedItems([{ ...item, type: type }]);
    }

    switch (action) {
      case 'create':
        setShowCreateModal(true);
        break;
      case 'rename':
        setShowRenameModal(true);
        break;
      case 'delete':
        setShowDeleteModal(true);
        break;
      case 'move':
        setFetchingFolders(true);
        setAvailableFolders([]);
        fetchAvailableFolders().finally(() => setFetchingFolders(false));
        setShowMoveModal(true);
        break;
      case 'reminder':
        setShowReminderModal(true);
        break;
      default:
        break;
    }
  };

  const closeModal = () => {
    setShowCreateModal(false);
    setShowRenameModal(false);
    setShowDeleteModal(false);
    setShowMoveModal(false);
    setShowPreviewModal(false);
    setShowReminderModal(false);
    setShowShareModal(false);
    setName('');
    setErrors({ name: '' });
    setSelectedItem(null);
    setSelectedDestinationFolder(null);
    setFetchingFolders(false);
    setAvailableFolders([]);
    setDeleteConfirmationText('');
  };

  const fetchAvailableFolders = async () => {
    try {
      const payload = {
        user_id: userId,
        folder_ids: selectedItems.length > 0 ? selectedItems.filter(item => item.type === 'folder').map(item => item.id) : selectedItem ? [selectedItem.id] : []
      };
      const response = await myFilesFolderList(payload);

      if (response.data.message === "success") {
        const folders = response.data.folders || response.data.data?.folders || [];
        setAvailableFolders(folders);
      } else {
        throw new Error(response.data.message || "Failed to fetch folders");
      }
    } catch (err) {
      console.error("Error fetching available folders:", err);
      toast.error(err.message || "Failed to fetch available folders");
      setAvailableFolders([]);
    }
  };

  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    setSelectedFiles(prev => [...prev, ...files]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!userId) return;
    if (selectedFiles.length === 0) {
      toast.error('Please select files to upload');
      return;
    }

    const formData = new FormData();
    formData.append('user_id', userId);

    if (currentFolder?.id) {
      formData.append('folder_id', currentFolder.id);
    }

    selectedFiles.forEach((file) => {
      formData.append('documents[]', file);
    });

    if (classifyAfterUpload) {
      setShowUploadModal(false);
      toast.info('Files are being processed. You will receive an email notification when complete.');

      try {
        const response = await uploadAndClassifyMyFiles(formData);
        const newFiles = response.data.data?.files || [];
        if (newFiles.length > 0) {
          setFiles(prevFiles => {
            const existingFileIds = new Set(prevFiles.map(file => file.id));
            const filteredNewFiles = newFiles.filter(file => !existingFileIds.has(file.id));
            return [...prevFiles, ...filteredNewFiles];
          });
        } else {
          const payload = {
            user_id: userId,
            folder_id: currentFolder?.id || null
          };
          const viewResponse = await myFilesFolderView(payload);
          if (viewResponse.data.message === 'success') {
            setFiles(viewResponse.data.data?.files || []);
          }
        }
        setSelectedFiles([]);
        setClassifyAfterUpload(false);
      } catch (err) {
        console.error('Error uploading and classifying files:', err);
        toast.error('Failed to upload and classify files');
      }
    } else {
      setLoading(true);
      setUploadProgress(0);

      try {
        const response = await uploadMyFiles(
          formData,
          (progressEvent) => {
            if (progressEvent.total) {
              const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setUploadProgress(progress);
            }
          }
        );

        const newFiles = response.data.data?.files || [];
        if (newFiles.length > 0) {
          setFiles(prevFiles => {
            const existingFileIds = new Set(prevFiles.map(file => file.id));
            const filteredNewFiles = newFiles.filter(file => !existingFileIds.has(file.id));
            return [...prevFiles, ...filteredNewFiles];
          });
        } else {
          const payload = {
            user_id: userId,
            folder_id: currentFolder?.id || null
          };
          const viewResponse = await myFilesFolderView(payload);
          if (viewResponse.data.message === 'success') {
            setFiles(viewResponse.data.data?.files || []);
          }
        }

        toast.success('Your documents have been uploaded successfully.');
        setShowUploadModal(false);
        setSelectedFiles([]);
        setUploadProgress(0);
        setClassifyAfterUpload(false);
      } catch (err) {
        console.error('Error uploading files:', err);
        toast.error('Failed to upload files');
      } finally {
        setLoading(false);
        setUploadProgress(0);
      }
    }
  };

  const handleCloseModal = () => {
    setShowUploadModal(false);
    if (!loading) {
      setSelectedFiles([]);
      setUploadProgress(0);
      setClassifyAfterUpload(false);
    }
  };

  const handleRemoveFile = (indexToRemove) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, index) => index !== indexToRemove));
  };

  const renderEmptyState = () => (
    <div className="">
      {/* Empty state content */}
    </div>
  );

  const renderContextMenu = () => {
    if (selectedItems.length === 0) return null;

    return (
      <div className="dropdown" style={{ position: 'absolute', top: '10px', right: '10px' }}>
        <span
          className="three-dots"
          onClick={() => setActiveDropdown(activeDropdown === 'context' ? null : 'context')}
        >
          •••
        </span>
        <ul
          className={`dropdown-menu ${activeDropdown === 'context' ? 'show' : ''}`}
          style={{ position: 'absolute', zIndex: 1002 }}
        >
          <li>
            <Button
              variant="link"
              className="dropdown-item"
              onClick={() => {
                handleShareFiles();
                setActiveDropdown(null);
              }}
            >
              <FaShare /> Share Selected
            </Button>
          </li>
          <li>
            <Button
              variant="link"
              className="dropdown-item"
              onClick={() => {
                openModal('multi', 'move');
                setActiveDropdown(null);
              }}
            >
              <FaArrowsAlt /> Move Selected
            </Button>
          </li>
          <li>
            <Button
              variant="link"
              className="dropdown-item"
              style={{ color: '#dc3545' }}
              onClick={() => {
                openModal('multi', 'delete');
                setActiveDropdown(null);
              }}
            >
              <RiDeleteBin5Line /> Delete Selected
            </Button>
          </li>
        </ul>
      </div>
    );
  };

  const handleTouchStart = (item, e) => {
    longPressTimer = setTimeout(() => {
      handleItemClick(e, item);
      setLongPressActiveId(item.id || item.folder_name || item.file_name);
      setLongPressType(item.type);
      setTimeout(() => {
        setLongPressActiveId(null);
        setLongPressType(null);
      }, 1000);
    }, 500);
  };

  const handleTouchEnd = () => {
    clearTimeout(longPressTimer);
  };

  const renderFolderItem = (folder) => (
    <div
      className={`file-card file-card-folder folder-border ${currentFolder?.id === folder.id ? "active-folder" : ""}
        ${isDraggingOver && dropTarget?.id === folder.id ? "drag-over" : ""} ${selectedItems.some((item) => item.id === folder.id && item.type === 'folder') ? 'selected' : ''}`}
      key={`folder-${folder.id}`}
      onClick={() => handleFolderClick(folder)}
      onContextMenu={(e) => {
        if (e.ctrlKey || e.metaKey) {
          e.preventDefault();
          handleItemClick(e, { ...folder, type: 'folder' });
        }
      }}
      onTouchStart={(e) => handleTouchStart({ ...folder, type: 'folder' }, e)}
      onTouchEnd={handleTouchEnd}
      onDoubleClick={undefined}
      draggable
      onDragStart={(e) => handleDragStart(e, { ...folder, type: 'folder' })}
      onDragOver={(e) => handleDragOverfolder(e, folder)}
      onDragLeave={handleDragLeavefolder}
      onDrop={(e) => handleDropfolder(e, folder)}
      style={{
        cursor: "pointer",
        zIndex: activeDropdown === folder.id ? 1001 : 1,
        opacity: draggedItem?.some((item) => item.id === folder.id && item.type === 'folder') ? 0.5 : 1,
        backgroundColor: selectedItems.some((item) => item.id === folder.id && item.type === 'folder')
          ? 'rgba(108, 71, 255, 0.1)'
          : '',
      }}
    >
      <div className="file-count" style={{
        backgroundColor: '#e6f0ff',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {folder.file_count}
      </div>
      <div className="file-icon-container">

        <div className="icon-background">
          <svg
            className="plain file-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 6H9L11 8H20C20.5523 8 21 8.44772 21 9V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V7C3 6.44772 3.44772 6 4 6Z"
              fill="#ffcc00"
            />
            <path d="M9 6L11 8H20V9H9L7 7H4V6H9Z" fill="#ffd633" />
          </svg>
        </div>
      </div>
      <div className="file-name">{highlightText(folder.folder_name, searchTerm)}</div>
      <div className="dropdown-container">
        <div className="file-type">FOLDER</div>
        <Dropdown
          trigger={['click']}
          overlay={
            <Menu className="custom-rc-dropdown-menu">
              <MenuItem key="rename" className="custom-rc-dropdown-item">
                <span
                  onClick={e => {
                    e.stopPropagation();
                    openModal('folder', 'rename', folder);
                  }}
                  className="custom-rc-dropdown-action"
                >
                  <MdDriveFileRenameOutline /> Rename
                </span>
              </MenuItem>
              <MenuItem key="move" className="custom-rc-dropdown-item">
                <span
                  onClick={e => {
                    e.stopPropagation();
                    openModal('folder', 'move', folder);
                  }}
                  className="custom-rc-dropdown-action"
                >
                  <FaArrowsAlt /> Move
                </span>
              </MenuItem>
              <MenuItem key="delete" className="custom-rc-dropdown-item">
                <span
                  onClick={e => {
                    e.stopPropagation();
                    openModal('folder', 'delete', folder);
                  }}
                  className="custom-rc-dropdown-action custom-rc-dropdown-danger"
                >
                  <RiDeleteBin5Line /> Delete
                </span>
              </MenuItem>
            </Menu>
          }
          animation="slide-up"
          onVisibleChange={(visible, e) => {
            if (e && e.domEvent) e.domEvent.stopPropagation();
            setActiveDropdown(visible ? folder.id : null);
          }}
          visible={activeDropdown === folder.id}
        >
          <span
            className="three-dots"
            onClick={e => {
              e.stopPropagation();
              setActiveDropdown(activeDropdown === folder.id ? null : folder.id);
              setSelectedItem(folder);
            }}
          >
            •••
          </span>
        </Dropdown>
      </div>
    </div>
  );

  const renderFileItem = (file) => {
    const { icon, class: cardClass, type } = getFileIconAndClass(file.file_name);
    return (
      <div
        className={`file-card ${cardClass} ${selectedItems.some((item) => item.id === file.id && item.type === 'file') ? 'selected' : ''}`}
        key={`file-${file.id}`}
        onClick={e => {
          if (activeDropdown === file.id) return; // Dropdown open hai toh preview mat khol
          handlePreview(file);
        }}
        onContextMenu={(e) => {
          if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
            handleItemClick(e, { ...file, type: 'file' });
          }
        }}
        onTouchStart={(e) => handleTouchStart({ ...file, type: 'file' }, e)}
        onTouchEnd={handleTouchEnd}
        draggable
        onDragStart={(e) => handleDragStart(e, { ...file, type: 'file' })}
        style={{
          zIndex: activeDropdown === file.id ? 1001 : 1,
          cursor: 'pointer',
          opacity: draggedItem?.some((item) => item.id === file.id && item.type === 'file') ? 0.5 : 1,
          backgroundColor: selectedItems.some((item) => item.id === file.id && item.type === 'file')
            ? 'rgba(108, 71, 255, 0.1)'
            : '',
          position: 'relative',
        }}
      >

        <div className='d-flex align-items-center justify-content-between'>
          <FavoriteStar
            file={file}
            userId={userId}
            loading={loading}
            onToggle={(newFav) => {
              setFiles(prevFiles =>
                prevFiles.map(f => f.id === file.id ? { ...f, is_favorite: newFav } : f)
              );
              setSelectedItem(prev => prev && prev.id === file.id ? { ...prev, is_favorite: newFav } : prev);
            }}
          />
          <div className="ms-2">
            <Button
              variant="link"
              className="p-0"
              onClick={(e) => {
                e.stopPropagation();
                openModal('file', 'reminder', file);
                setActiveDropdown(null);
              }}
              style={{
                backgroundColor: file.has_reminder ? '#dc3545' : '#6c757d',
                borderRadius: '50%',
                width: '25px',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <BiAlarm size={15} color="#fff" />
            </Button>
          </div>
        </div>
        <div className="file-icon-container">{icon}</div>
        <div className="file-name">{highlightText(file.file_name, searchTerm)}</div>
        <div className="dropdown-container">
          <div className="file-type">{type}</div>
          <Dropdown
            trigger={['click']}
            overlay={
              <Menu className="custom-rc-dropdown-menu">
                <MenuItem key="move" className="custom-rc-dropdown-item">
                  <span
                    onClick={() => {
                      openModal('file', 'move', file);
                    }}
                    className="custom-rc-dropdown-action"
                  >
                    <FaArrowsAlt /> Move
                  </span>
                </MenuItem>

                <MenuItem key="summary" className="custom-rc-dropdown-item">
                  <span
                    onClick={() => openSummaryForFile(file)}
                    className="custom-rc-dropdown-action"
                  >
                    <i className="bi bi-file-text" /> Summary
                  </span>
                </MenuItem>
                <MenuItem key="share" className="custom-rc-dropdown-item">
                  <span
                    onClick={() => {
                      setSelectedItems([{ ...file, type: 'file' }]);
                      setShowShareModal(true);
                    }}
                    className="custom-rc-dropdown-action"
                  >
                    <FaShare /> Share
                  </span>
                </MenuItem>
                <MenuItem key="metadata" className="custom-rc-dropdown-item">
                  <span
                    onClick={() => {
                      setSelectedMetadata(file.metadata && Object.keys(file.metadata).length > 0 ? file.metadata : null);
                      setShowMetadataModal(true);
                    }}
                    className="custom-rc-dropdown-action"
                  >
                    <i className="bi bi-info-square" /> Metadata
                  </span>
                </MenuItem>
                <MenuItem key="tag" className="custom-rc-dropdown-item">
                  <span
                    onClick={e => {
                      e.stopPropagation();
                      openModal('file', 'tag', file);
                    }}
                    className="custom-rc-dropdown-action"
                  >
                    <MyFilesTag file={file} userId={userId} fetchFiles={() => setRefreshTrigger(Date.now())} />
                  </span>
                </MenuItem>
                <MenuItem key="delete" className="custom-rc-dropdown-item">
                  <span
                    onClick={() => {
                      openModal('file', 'delete', file);
                    }}
                    className="custom-rc-dropdown-danger custom-rc-dropdown-action "
                  >
                    <RiDeleteBin5Line /> Delete
                  </span>
                </MenuItem>
              </Menu>
            }
            animation="slide-up"
            onVisibleChange={(visible, e) => {
              if (e && e.domEvent) e.domEvent.stopPropagation();
              setActiveDropdown(visible ? file.id : null);
            }}
            visible={activeDropdown === file.id}
          >
            <span
              className="three-dots"
              onClick={e => {
                e.stopPropagation();
                setActiveDropdown(activeDropdown === file.id ? null : file.id);
                setSelectedItem(file);
              }}
            >
              •••
            </span>
          </Dropdown>
        </div>
      </div>
    );
  };

  const getFileIconAndClass = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return {
          icon: (
            <div className="icon-background">
              <img src={pdf} alt="" />
            </div>
          ),
          class: 'file-card-pdf pdf-border',
          type: 'PDF'
        };
      case 'jpg':
      case 'jpeg':
      case 'png':
        return {
          icon: (
            <div className="icon-background">
              <img src={image} alt="" />
            </div>
          ),
          class: 'file-card-image image-border',
          type: 'IMAGE'
        };
      case 'gif':
        return {
          icon: (
            <div className="icon-background">
              <svg className="file-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22H18C18.5523 22 19 21.5523 19 21V8L14 2Z" fill="#4dff88" />
                <path d="M14 2V8H19" fill="#66ff99" />
                <path d="M9 12L11 14L14 11L16 14H8L9 12Z" fill="#fff" />
              </svg>
            </div>
          ),
          class: 'file-card-image image-border',
          type: 'IMAGE'
        };
      case 'doc':
      case 'docx':
        return {
          icon: (
            <div className="icon-background">
              <img src={docx} alt="" />
            </div>
          ),
          class: 'file-card-doc doc-border',
          type: 'DOC'
        };
      default:
        return {
          icon: (
            <div className="icon-background">
              <img src={folder} alt="" />
            </div>
          ),
          class: 'file-card-doc default-border',
          type: 'FILE'
        };
    }
  };

  const filteredItems = () => {
    let filteredFolders = folders;
    let filteredFiles = files;

    if (searchTerm.trim()) {
      const lowerSearchTerm = searchTerm.toLowerCase();
      filteredFolders = folders.filter((folder) =>
        folder.folder_name.toLowerCase().includes(lowerSearchTerm)
      );
      filteredFiles = files.filter((file) =>
        file.file_name.toLowerCase().includes(lowerSearchTerm)
      );
    }

    switch (filterType) {
      case 'folders':
        filteredFiles = [];
        break;
      case 'pdfs':
        filteredFolders = [];
        filteredFiles = filteredFiles.filter((f) =>
          f.file_name.toLowerCase().endsWith('.pdf')
        );
        break;
      case 'images':
        filteredFolders = [];
        filteredFiles = filteredFiles.filter((f) =>
          ['.jpg', '.jpeg', '.png', '.gif'].some((ext) =>
            f.file_name.toLowerCase().endsWith(ext)
          )
        );
        break;
      case 'docs':
        filteredFolders = [];
        filteredFiles = filteredFiles.filter((f) =>
          ['.doc', '.docx'].some((ext) =>
            f.file_name.toLowerCase().endsWith(ext)
          )
        );
        break;
      case 'other':
        filteredFolders = [];
        filteredFiles = filteredFiles.filter(f => !['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.doc', '.docx'].some(ext => f.file_name.toLowerCase().endsWith(ext)));
        break;
      case 'favorites':
        filteredFolders = [];
        filteredFiles = filteredFiles.filter(f => f.is_favorite);
        break;
      case 'all':
      default:
        break;
    }

    return { filteredFolders, filteredFiles };
  };

  const { filteredFolders, filteredFiles } = filteredItems();

  const handleShareFiles = async () => {
    if (!selectedItems.length) {
      toast.error("Please select at least one file to share.");
      return;
    }
    if (selectedItems.length > 5) {
      toast.error("You can share a maximum 5 files at one time.");
      return;
    }
    setShowShareModal(true);
  };

  useEffect(() => {
    const handleKeyDown = async (e) => {
      // Modal open hai toh global paste/cut को disable kar do
      if (showDeleteModal || showCreateModal || showRenameModal || showMoveModal || showPreviewModal || showReminderModal || showShareModal || showUploadModal) {
        return;
      }

      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'x') {
        e.preventDefault();
        if (selectedItems.length > 0) {
          setClipboardItems(selectedItems);
          toast.info('Items copied. Go to a folder and press Ctrl+V to move.');
        }
      }
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v' && !e.shiftKey) {
        e.preventDefault();
        if (clipboardItems.length > 0) {
          setLoading(true);
          try {
            const folderIds = clipboardItems.filter(item => item.type === 'folder').map(item => item.id);
            const fileIds = clipboardItems.filter(item => item.type === 'file').map(item => item.id);
            const payload = {
              user_id: userId,
              folder_ids: folderIds,
              file_ids: fileIds,
              target_folder_id: currentFolder?.id || null
            };
            await myFilesFolderMove(payload);
            toast.success(`${clipboardItems.length} Item moved successfully`);
            setRefreshTrigger(Date.now());
            setSelectedItems([]);
            setClipboardItems([]);
            if (onMove) {
              onMove({ movedItems: clipboardItems, targetFolder: currentFolder, userId });
            }
          } catch (err) {
            console.error('Error moving items:', err);
            toast.error(err.message || 'Failed to move items');
          } finally {
            setLoading(false);
          }
        } else if (clipboardData) {
          handlePasteToMyFiles();
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedItems, clipboardItems, clipboardData, currentFolder, userId, onMove, showDeleteModal, showCreateModal, showRenameModal, showMoveModal, showPreviewModal, showReminderModal, showShareModal, showUploadModal]);

  const handleDropOnRoot = async (e) => {
    e.preventDefault();
    setIsDraggingOver(false);
    if (!draggedItem || draggedItem.length === 0) return;
    try {
      setLoading(true);
      const folderIds = draggedItem.filter((item) => item.type === 'folder').map((item) => item.id);
      const fileIds = draggedItem.filter((item) => item.type === 'file').map((item) => item.id);
      const payload = {
        user_id: userId,
        folder_ids: folderIds,
        file_ids: fileIds,
        target_folder_id: null
      };
      await myFilesFolderMove(payload);
      toast.success(`${draggedItem.length} File moved to Home`);
      setRefreshTrigger(Date.now());
      setSelectedItems([]);
      if (onMove) {
        onMove({ movedItems: draggedItem, targetFolder: null, userId });
      }
    } catch (err) {
      console.error('Error moving items:', err);
      toast.error(err.message || 'Failed to move items');
    } finally {
      setLoading(false);
      setDraggedItem(null);
      setDropTarget(null);
    }
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <section>
        <div className="container-main rounded">
          {infoMessage && (
            <Alert variant="info" className="p-2 ps-3 mb-2 text-start"  >
              <i className='bi bi-x-circle me-2 cur-pointer' onClick={() => setInfoMessage("")}></i>
              {infoMessage}
            </Alert>
          )}
          {renderContextMenu()}
          <div className="folder-header rounded bg-light-subtle">
            <div className="header-row">
              <div className="my-files-folder-search-container">
                <input
                  type="text"
                  className="form-control my-files-folder-search-input"
                  placeholder="Type to search... "
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </div>
              <div className="actions-container">
                {folderStack.length < MAX_FOLDER_DEPTH && (
                  <Button
                    variant="outline-secondary"
                    className="filter-btn"
                    onClick={() => openModal("folder", "create")}
                    disabled={loading}
                  >
                    <i className="bi bi-folder-plus" /> New Folder
                  </Button>
                )}
                {selectedItems.length > 0 && (
                  <>
                    {selectedItems.some(item => item.type === 'file') && (
                      <Button
                        variant="outline-secondary"
                        className="filter-btn ms-2"
                        onClick={handleShareFiles}
                        disabled={loading}
                      >
                        <i className="bi bi-share" /> Share
                      </Button>
                    )}
                    <Button
                      variant="outline-danger"
                      className="filter-btn ms-2"
                      onClick={() => openModal('multi', 'delete')}
                      disabled={loading}
                    >
                      <RiDeleteBin5Line /> Delete
                    </Button>
                  </>
                )}
                <Button
                  className="uploade-btn text-white"
                  onClick={() => setShowUploadModal(true)}
                  disabled={loading}
                >
                  <i className="bi bi-upload" /> Upload
                </Button>
              </div>
            </div>
            <div className="divider-row"></div>
            <div className="header-row">
              <div className="breadcrumb-nav">{getBreadcrumbs()}</div>
              <div className="filter-row">
                <div className="header-filter-tabs">
                  {['name', 'date_modified'].map((col) => (
                    <div
                      key={col}
                      onClick={() => handleSort(col)}
                      className={`d-flex align-items-center gap-1 px-3 py-1 rounded cursor-pointer sort-item ${sortColumn === col ? "active-sort" : "inactive-sort"}`}
                    >
                      {col.replace("_", " ").toUpperCase()}
                      {sortColumn === col &&
                        (sortDirection === "asc" ? (
                          <AiOutlineArrowUp size={16} />
                        ) : (
                          <AiOutlineArrowDown size={16} />
                        ))}
                    </div>
                  ))}
                  <Dropdown
                    trigger={['click']}
                    overlay={
                      <Menu className="myfiles-rc-dropdown-menu" style={{ minWidth: "185px", border: "1px solid #dee2e6" }}>
                        <MenuItem key="all" className="myfiles-rc-dropdown-item">
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              setFilterType('all');
                            }}
                            className="myfiles-rc-dropdown-action"
                          >
                            <RiFileList3Line className="me-2" /> All Files {folders.length + files.length}
                          </span>
                        </MenuItem>
                        <MenuItem key="favorites" className="myfiles-rc-dropdown-item">
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              setFilterType('favorites');
                            }}
                            className="myfiles-rc-dropdown-action"
                          >
                            <FaStar className="me-2" style={{ color: '#FFD700' }} /> Favorites {files.filter(f => f.is_favorite).length}
                          </span>
                        </MenuItem>
                        <MenuItem key="folders" className="myfiles-rc-dropdown-item">
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              setFilterType('folders');
                            }}
                            className="myfiles-rc-dropdown-action"
                          >
                            <FaFolderClosed className="me-2" /> Folders {folders.length}
                          </span>
                        </MenuItem>
                        <MenuItem key="pdfs" className="myfiles-rc-dropdown-item">
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              setFilterType('pdfs');
                            }}
                            className="myfiles-rc-dropdown-action"
                          >
                            <MdOutlinePictureAsPdf className="me-2" /> PDFs {files.filter((f) => f.file_name.toLowerCase().endsWith('.pdf')).length}
                          </span>
                        </MenuItem>
                        <MenuItem key="images" className="myfiles-rc-dropdown-item">
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              setFilterType('images');
                            }}
                            className="myfiles-rc-dropdown-action"
                          >
                            <IoImages className="me-2" /> Images {files.filter((f) => ['.jpg', '.jpeg', '.png', '.gif'].some((ext) => f.file_name.toLowerCase().endsWith(ext))).length}
                          </span>
                        </MenuItem>
                        <MenuItem key="docs" className="myfiles-rc-dropdown-item">
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              setFilterType('docs');
                            }}
                            className="myfiles-rc-dropdown-action"
                          >
                            <BsFiletypeDocx className="me-2" /> Docx {files.filter((f) => ['.doc', '.docx'].some((ext) => f.file_name.toLowerCase().endsWith(ext))).length}
                          </span>
                        </MenuItem>
                        <MenuItem key="other" className="myfiles-rc-dropdown-item">
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              setFilterType('other');
                            }}
                            className="myfiles-rc-dropdown-action"
                          >
                            <i className="bi bi-file-earmark me-2" /> Other {files.filter((f) => {
                              const name = f.file_name.toLowerCase();
                              return !['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.doc', '.docx'].some(ext => name.endsWith(ext));
                            }).length}
                          </span>
                        </MenuItem>
                      </Menu>
                    }
                    animation="slide-up"
                    onVisibleChange={visible => setFilterDropdownOpen(visible)}
                  >
                    <button className={`filter-dropdown-btn${filterDropdownOpen ? ' open' : ''}`}>
                      {filterType === 'all' && <RiFileList3Line className="me-2" />}
                      {filterType === 'favorites' && <FaStar className="me-2" style={{ color: '#FFD700' }} />}
                      {filterType === 'folders' && <FaFolderClosed className="me-2" />}
                      {filterType === 'pdfs' && <MdOutlinePictureAsPdf className="me-2" />}
                      {filterType === 'images' && <IoImages className="me-2" />}
                      {filterType === 'docs' && <BsFiletypeDocx className="me-2" />}
                      {filterType === 'other' && <i className="bi bi-file-earmark me-2" />}
                      Show: {filterType === 'all' ? 'All Files' : filterType === 'favorites' ? 'Favorites' : filterType === 'folders' ? 'Folders' : filterType === 'pdfs' ? 'PDFs' : filterType === 'images' ? 'Images' : filterType === 'docs' ? 'Docx' : 'Other'}
                      <span className="filter-dropdown-arrow"><BiChevronDown /></span>
                    </button>
                  </Dropdown>
                </div>
              </div>
            </div>

          </div>

          <ReminderModal
            show={showReminderModal}
            onHide={() => {
              setShowReminderModal(false);
              setRefreshTrigger(Date.now());
              if (typeof onReminderUpdate === 'function') onReminderUpdate();
            }}
            file={selectedItem}
            userId={userId}
            folderId={currentFolder?.id}
            setReminderStatus={(fileId, status, reminderData) => {
              setReminderStatus((prev) => ({ ...prev, [fileId]: status }));
              setFiles((prevFiles) =>
                prevFiles.map((file) =>
                  file.id === fileId
                    ? { ...file, reminder: status ? reminderData : null, has_reminder: status }
                    : file
                )
              );
              setSelectedItem((prev) =>
                prev && prev.id === fileId
                  ? { ...prev, reminder: status ? reminderData : null, has_reminder: status }
                  : prev
              );
            }}
          />

          {showPreviewModal && previewFile && (
            <div
              className="modal show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 1050 }}
              onClick={(e) => e.target === e.currentTarget && setShowPreviewModal(false)}
            >
              <div className="modal-dialog modal-xl">
                <div className="modal-content rounded-3 shadow-lg" style={{ height: "90vh" }}>
                  <div className="modal-header">
                    <h5 className="modal-title fw-bold text-dark" style={{ fontSize: "1rem" }}>
                      {previewFile.file_name}
                    </h5>
                    <Button
                      variant="link"
                      onClick={closeModal}
                      disabled={loading}
                      className="btn btn-close"
                    >
                      <i className="bi bi-x-lg text-dark" />
                    </Button>
                  </div>
                  <div className="modal-body p-4" style={{ overflow: "auto", height: "calc(90vh - 120px)" }}>
                    {isPreviewLoading ? (
                      <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3 text-muted">Loading preview...</p>
                      </div>
                    ) : previewFile.file_name.toLowerCase().endsWith(".pdf") ? (
                      <iframe
                        src={previewFile.file_path}
                        style={{ width: "100%", height: "100%", border: "none" }}
                        title={previewFile.file_name}
                      ></iframe>
                    ) : previewFile.file_name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/) ? (
                      <img
                        src={previewFile.file_path}
                        alt={previewFile.file_name}
                        style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
                      />
                    ) : previewFile.file_name.toLowerCase().endsWith('.svg') ? (
                      <img
                        src={previewContent || previewFile.file_path}
                        alt={previewFile.file_name}
                        style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
                      />
                    ) : previewFile.file_name.toLowerCase().match(/\.(doc|docx)$/) && previewContent ? (
                      <div
                        className="docx-preview p-3 bg-light rounded-3"
                        style={{ height: "100%", overflow: "visible" }}
                        dangerouslySetInnerHTML={{ __html: previewContent }}
                      ></div>
                    ) : previewFile.file_name.toLowerCase().match(/\.(txt|csv)$/) && previewContent ? (
                      <pre className="bg-light rounded-3 p-3" style={{ maxHeight: "70vh", overflow: "auto" }}>{previewContent}</pre>
                    ) : previewFile.file_name.toLowerCase().endsWith('.xlsx') && previewContent ? (
                      <div className="xlsx-preview p-3 bg-light rounded-3" style={{ height: "100%", overflow: "auto" }}
                        dangerouslySetInnerHTML={{ __html: previewContent }}
                      ></div>
                    ) : previewFile.file_name.toLowerCase().match(/\.(ppt|pptx)$/) ? (
                      <iframe
                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewFile.file_path)}`}
                        style={{ width: "100%", height: "100%", border: "none" }}
                        title={previewFile.file_name}
                      ></iframe>
                    ) : (
                      <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center p-5">
                        <i className="bi bi-file-earmark-text" style={{ fontSize: "5rem", color: "#6c757d" }}></i>
                        <p className="mt-3 text-muted">Preview not available for this file type</p>
                        <a
                          href={previewFile.file_path}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary mt-2 rounded-3"
                        >
                          Open in new tab
                        </a>
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <small className="text-muted">
                      Last modified: {new Date(previewFile.updated_at || previewFile.created_at).toLocaleString()}
                    </small>
                    <button
                      type="button"
                      className="btn btn-secondary rounded-3"
                      onClick={() => setShowPreviewModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <FolderActionModal
            modalState={{
              visible: showCreateModal || showRenameModal,
              actionType,
              modalType,
              selectedItem
            }}
            onClose={() => {
              setShowCreateModal(false);
              setShowRenameModal(false);
              setName('');
              setErrors({ name: '' });
              setSelectedItem(null);
            }}
            userId={userId}
            currentFolder={currentFolder}
            setRefreshTrigger={setRefreshTrigger}
            setSelectedItems={setSelectedItems}
            toast={toast}
          />

          {/* Delete Modal */}
          <DeleteFilesModal
            show={showDeleteModal}
            onHide={closeModal}
            selectedFiles={
              modalType === 'folder'
                ? []
                : modalType === 'multi'
                  ? selectedItems.filter(item => item.type === 'file').map(item => item.id)
                  : modalType === 'file'
                    ? [selectedItem?.id]
                    : []
            }
            selectedFolders={
              modalType === 'folder'
                ? [selectedItem?.id]
                : modalType === 'multi'
                  ? selectedItems.filter(item => item.type === 'folder').map(item => item.id)
                  : modalType === 'folder'
                    ? [selectedItem?.id]
                    : []
            }
            userId={userId}
            fetchFiles={() => setRefreshTrigger(Date.now())}
            setSelectedFiles={setSelectedItems}
            setSelectedFolders={setSelectedItems}
            setIsSelectAll={null}
            toast={toast}
            deleteType="folder"
            title={
              modalType === 'multi'
                ? `Delete ${selectedItems.length} Item${selectedItems.length > 1 ? 's' : ''}`
                : modalType === 'folder'
                  ? 'Delete Folder'
                  : 'Delete File'
            }
            message={
              modalType === 'multi'
                ? `Are you sure you want to delete ${selectedItems.length} selected item${selectedItems.length > 1 ? 's' : ''}? Type PERMANENTLY DELETE to confirm.`
                : `Are you sure you want to delete this ${modalType}: "${selectedItem?.folder_name || selectedItem?.file_name}"? Type PERMANENTLY DELETE to confirm.`
            }
            deleteButtonText={loading ? 'Deleting...' : 'Delete'}
          />


          {showMoveModal && (
            <MoveModal
              show={showMoveModal}
              onHide={closeModal}
              loading={loading}
              modalType={modalType}
              selectedItems={selectedItems}
              selectedItem={selectedItem}
              availableFolders={availableFolders}
              fetchingFolders={fetchingFolders}
              userId={userId}
              onMove={onMove}
              setLoading={setLoading}
              setRefreshTrigger={setRefreshTrigger}
              closeModal={closeModal}
              setSelectedItems={setSelectedItems}
            />
          )}

          {showUploadModal && (
            <div
              className="modal show d-block"
              tabIndex="-1"
              onClick={(e) => e.target === e.currentTarget && setShowUploadModal(false)}
            >
              <div className="modal-dialog modal-lg" style={{ maxWidth: "600px" }}>
                <div className="modal-content rounded-3 shadow-lg" style={{ border: "none" }}>
                  <div className="modal-header">
                    <h5 className="modal-title fw-bold" style={{ fontSize: "1.5rem", color: "#1a1a1a" }}>
                      Upload Documents
                    </h5>
                    <Button
                      variant="link"
                      onClick={handleCloseModal}
                      disabled={loading}
                      className="btn btn-close"
                    >
                      <i className="bi bi-x-lg" />
                    </Button>
                  </div>
                  <div className="modal-body p-4">
                    <div
                      className={`border border-2 border-dashed rounded-3 p-4 text-center mb-4 cursor-pointer ${isDragging ? "border-primary bg-primary bg-opacity-10" : "border-secondary bg-light"}`}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onClick={() => fileInputRef.current.click()}
                      disabled={loading}
                    >
                      <input
                        type="file"
                        ref={fileInputRef}
                        className="d-none"
                        multiple
                        onChange={handleFileSelect}
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif"
                        disabled={loading}
                      />
                      <i className="bi bi-cloud-upload fs-2 text-muted mb-2 d-block"></i>
                      <p className="mb-2 text-muted">
                        {isDragging ? "Drop your files here" : "Drag & drop files here or click to upload"}
                      </p>
                    </div>
                    {selectedFiles.length > 0 && (
                      <div className="mb-4 p-3 bg-light rounded-3" style={{ maxHeight: "200px", overflowY: "auto" }}>
                        <ul className="list-unstyled mb-0">
                          {selectedFiles.map((file, index) => (
                            <li key={index} className="d-flex justify-content-between align-items-center p-2 border-bottom">
                              <div>
                                <span className="text-dark" style={{ fontSize: "0.9rem" }}>
                                  {file.name}
                                </span>
                              </div>
                              <div>
                                <button
                                  className="btn btn-link text-danger p-0"
                                  onClick={() => handleRemoveFile(index)}
                                  disabled={loading}
                                >
                                  <i className="bi bi-x-circle align-items-end"></i>
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                  </div>
                  <div className="modal-footer d-flex justify-content-between align-items-center">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="classifyAfterUpload"
                        checked={classifyAfterUpload}
                        onChange={(e) => setClassifyAfterUpload(e.target.checked)}
                        disabled={loading}
                      />
                      <label className="form-check-label" htmlFor="classifyAfterUpload">
                        Organize and upload
                      </label>
                    </div>
                    <div className="d-flex">
                      <Button
                        variant="outline-secondary"
                        onClick={handleCloseModal}
                        disabled={loading}
                        className="rounded-3 me-2"
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        onClick={handleUpload}
                        disabled={selectedFiles.length === 0 || loading}
                        className="rounded-3"
                      >
                        {classifyAfterUpload ? "Organize" : "Upload"}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <ShareDocumentModal
            show={showShareModal}
            onHide={() => setShowShareModal(false)}
            selectedFiles={selectedItems.filter(item => item.type === 'file')}
            userId={userId}
          />

          <MyFilesMetadata
            show={showMetadataModal}
            onHide={() => {
              setShowMetadataModal(false);
              setSelectedMetadata(null);
            }}
            metadata={selectedMetadata}
          />

          <div className="file-list-item">
            {filteredFolders.length > 0 || filteredFiles.length > 0
              ? sortItems(filteredFolders, filteredFiles).map((item) => (
                <div
                  key={item.type === "folder" ? `folder-${item.id}` : `file-${item.id}`}
                >
                  {item.type === "folder" ? renderFolderItem(item) : renderFileItem(item)}
                </div>
              ))
              : renderEmptyState()}
          </div>
        </div>
      </section>
    </>
  );
};

export default MyFilesFolder;